import React, { useEffect, useState } from 'react';
import Box, {
    Item
  } from 'devextreme-react/box';
import { Button } from 'devextreme-react/button';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { useDispatch } from 'react-redux'
import 'react-tabs/style/react-tabs.css';
import Graduaciones from '../../components/graduaciones/Graduaciones';
import { defaultCliente } from '../../data/cliente';
import http from '../../utils/http';
import uri from '../../utils/uri';
import Appointment from '../../components/appointment';
import DialogPhoto from '../../components/dialog/DialogPhoto';
import moment from 'moment';
import Icon from '../../components/controls/Icon';
import Contactologia from '../../components/concactologia';
import SMS from '../../components/sms';
import { openDialog } from '../../store/cliente/clienteDialogReducer';
import Nuevo from "./Nuevo";
import Bills from '../bills/Bills';
import Quotes from '../bills/Quotes';
import Sclerals from '../../components/sclerals';

const FichaCliente = props => {
    

    const { search } = props.location;

    const tabIndexInit = search ? parseInt(search.substring(3)) : 0; 

    const dispatch = useDispatch();

    const param = props.match.params.id;
    const id = parseInt(param);

    const [tabIndex, setTabIndex] = useState(tabIndexInit);
    const [cliente, setcliente] = useState(defaultCliente);
    const [file, setFile] = React.useState("");

    const loadData = () => {
        http(uri.clients.getById(id)).asGet().then(c => {
            setcliente({...defaultCliente, ...c});
        });
    }

    useEffect(()=>{
        loadData();
    },[id]);

    const onEdit = () => {
        loadData();
    }

    const onSave = (e) => {
        http(`files/client/${id}/get`).asGetFile().then(resp => {
            setFile(resp);
        });
    }

    useEffect(()=>{
        onSave(); 
    },[id]);

    return (
        <div className="container">
            <Nuevo onSave={onEdit}/>
            <Box direction="row" width="100%" height={75}>
                <Item ratio={1}>               
                    <Button className="btn-header-menu" icon="edit" text="Editar" onClick={() => dispatch(openDialog({open : true, id : id}))}  stylingMode="outlined" type='default'/>
                </Item>
                <Item ratio={1}>
                    <Button className="btn-header-menu" icon="message" text="Avisar" onClick={() => setTabIndex(2)} stylingMode="outlined" type='default'/>
                </Item>
                <Item ratio={1}>
                    <DialogPhoto title="Asignar foto" icon="card" id={id} onSave={onSave}/>
                </Item>
                <Item ratio={1}>
                    <Button className="btn-header-menu" icon="clock" text="Ver Avisos" onClick={() => setTabIndex(2)} stylingMode="outlined" type='default'/>
                </Item>
                <Item ratio={1}>
                    <Button className="btn-header-menu" icon="event" text="Citas" onClick={() => setTabIndex(3)} stylingMode="outlined" type='default' />
                </Item>
                <Item ratio={3}></Item>
            </Box>
            <Box direction="row" width="100%" height={500}>
                <Item ratio={1}>
                    <div className="form-avatar">
                        {file && <img className="form-avatar" src={URL.createObjectURL(file)} alt={file.name} />}                        
                    </div>
                    <p>Codigo:<b>{cliente.id}</b> </p>
                    <p><b>{cliente.name} {cliente.lastName}</b></p>
                    <p>{cliente.identification}</p>
                    <p>{moment(cliente.birthdate).format("DD/MM/YYYY")} (<b>{moment(cliente.birthdate).fromNow(true).replace('years','años')}</b>)</p>
                    <p>{cliente.category?.name}</p>
                    <p><Icon iconName='tel'/>{cliente.phoneNumber}</p>
                    <p><Icon iconName='email'/> {cliente.correo}</p>
                    <p><i className="fas fa-map-marker-alt"></i> {cliente.address}</p>
                </Item>
                <Item ratio={3}>
                    <Tabs selectedIndex={tabIndex} onSelect={index => setTabIndex(index)}>
                        
                        <TabList>
                            <Tab>Graduaciones</Tab>
                            <Tab>Lentes de contactos</Tab>
                            <Tab>Lentes de Esclerales</Tab>
                            <Tab>Avisos</Tab>
                            <Tab>Citas</Tab>
                            <Tab>Proformas</Tab>
                            <Tab>Facturas</Tab>
                        </TabList>

                        <TabPanel>   
                            <Graduaciones id={id}/>                      
                        </TabPanel>
                        <TabPanel>
                            <Contactologia id={id}/>
                        </TabPanel>
                        <TabPanel>
                            <Sclerals clientId={id}/>
                        </TabPanel>
                        <TabPanel>
                            <SMS clientId={id}/>
                        </TabPanel>
                        <TabPanel>
                            <Appointment id={id}/>
                        </TabPanel>
                        <TabPanel>
                            <Quotes clientId={id}/>
                        </TabPanel>
                        <TabPanel>
                            <Bills clientId={id}/>
                        </TabPanel>
                    </Tabs>
                </Item>
               
            </Box>
        </div>
    );
}

export default FichaCliente;
